package com.neurobs.ccabserver.administrator.view

import com.neurobs.ccab.{ParameterType, SequenceElement, SequenceStatus, SessionData, SessionState}
import com.neurobs.js.dom.{ButtonButton, CollapsibleBox, Grid, HideableRowGrid, InputCheckBox, StopWatchElement}
import com.neurobs.js.dom.Grid._
import com.neurobs.js.view.{Container, Gui}
import com.neurobs.util.Logger
import org.scalajs.dom.raw.HTMLElement
import scalatags.JsDom.all._

import scala.collection.mutable.ArrayBuffer

class TestSessionView (logger: Logger, showComments: Boolean, analysisView: Boolean = false) {
	import com.neurobs.js.dom.ElementFactory._
	import com.neurobs.js.dom.DOMViewElement._
	import TestSessionView._

	private val panel = new PanelView(title = "", showRefresh = false, fullWidth = true, styles = Some(Array(("background-color", "#004"), ("color", "#FFFFFF"))))
	private val rightGrid = new HideableRowGrid(fullWidth = false, emGapSize, defaultAlign = Grid.alignCenter)
	private val infoTableContainer = div(style := "display: inline-block").render
	private var primaryVisible = false
	private var secondaryVisible = false

	def primarySequenceId: Option[SequenceElement.Id] = if (primaryVisible) test.currentSequenceId else None
	def secondarySequenceId: Option[SequenceElement.Id] = if (secondaryVisible) sequenceElement.currentSequenceId else None

	val controlView = new SessionControlView

	val sequenceList = new TestListView

	val commentsContainer: Container = div().render

	//val log = new TestLogView

	val sequenceElement = new TestStateView//new SequenceElementView(logger)
	def setSequenceElementVisible(visible: Boolean): Unit = {
		secondaryVisible = visible
		rightGrid.setRowVisible(toElement(sequenceElement.container), visible)
	}

	val test = new TestStateView
	def setTestVisible(visible: Boolean): Unit = {
		primaryVisible = visible
		rightGrid.setRowVisible(toElement(test.container), visible)
	}

	val endSessionButton: ButtonButton = makeButton(caption = "End Session")

	val pauseBetweenTestsCheck: InputCheckBox = makeCheckbox()
	private val pauseBetweenDiv = div("Pause Between Tests: ", pauseBetweenTestsCheck.input).render
	def setPauseBetweenTestsVisible(visible: Boolean): Unit = pauseBetweenDiv.style.display = if (visible) "inline-block" else "none"

	val container: Container = {
		val leftGrid = new Grid(fullWidth = false, emGapSize)
		leftGrid.addRow((infoTableContainer, Grid.alignCenter))
		leftGrid.addRow((sequenceList.container, Grid.alignCenter))
		if (!analysisView) {
			leftGrid.addRow((pauseBetweenDiv, Grid.alignCenter))
		}

		//rightGrid.addRow(toElement(log.container))
		if (!analysisView) {
			rightGrid.addRow(controlView.container)
		}
		if (showComments) rightGrid.addRow(CollapsibleBox("Session Comments", toElement(commentsContainer)).container)
		if (!analysisView) {
			rightGrid.addRow(test.container)
		}
		setTestVisible(visible = false)
		rightGrid.addRow(sequenceElement.container)
		setSequenceElementVisible(visible = false)
		rightGrid.setRowVisible(toElement(sequenceElement.container), visible = false)
		if (!analysisView) {
			rightGrid.addRow(endSessionButton.button)
		}

		panel.grid.addRowCells(Seq(leftGrid.container, rightGrid.container))

		panel.container
	}

	def setButtonStates(status: SequenceStatus.Value): Unit = {
		rightGrid.setRowVisible(endSessionButton.button, status == SequenceStatus.Stopped || status == SequenceStatus.Finished)
	}

	def updateInfoTable(data: SessionData, state: SessionState, chatAPI: String): Unit = {
		infoTableContainer.innerHTML = ""
		infoTableContainer.appendChild(makeInfoTable(data, state, chatAPI))
		panel.titleText.setValue(data.subject_name + data.reporting_id.map(i => s" ($i)").getOrElse(""))
	}
}

object TestSessionView {
	import com.neurobs.js.dom.ElementFactory._

	private val emGapSize: Double = 1

	def makeInfoTable(data: SessionData, state: SessionState, chatAPI: String): HTMLElement = {
		val rows = ArrayBuffer[(HTMLElement, HTMLElement)](
				("Start Time:", Gui.toLocalTime(data.start_time)),
				("Elapsed Time:", StopWatchElement.make(data.start_time)),
				("Group:", data.group.name),
				("Sequence:", state.seq.name)
			)
		state.group_set.config.foreach(c => rows.append(("Configuration:", c)))
		val testVersion = stringToElement(data.test_version.getOrElse("dev"))
		rows.append(("Test Version:", testVersion))
		state.group_set.params.view.filter(p => data.group.params.find(_.name == p.name).map(_.`type` == ParameterType.Standard).getOrElse(false)).foreach(p => rows.append((p.name + ":", p.value)))
		rows.append(("Audio Attenuation:", state.attenuation.map(a => s"${(a * 100).round} dB").getOrElse[String](default = "None")))
		rows.append(("Chat API:", chatAPI))
		makeParameterTable(rows.toArray)
	}
}